// extracted by mini-css-extract-plugin
export default {"container":"NZSr3UO8","title":"s7pJpDhZ","subtitle":"HGuRn23Q","mobile":"mobile"};